import { spacingMixin } from '@zillow/constellation';
import { css } from 'styled-components';

const getMargin = ({ noMargin }) => {
  if (noMargin) {
    return css`
      margin: 0;
    `;
  }
  return css`
    margin: auto;
  `;
};

export default (props) =>
  props.theme &&
  props.theme.ns &&
  css`
    ${getMargin}
    text-align: center;
    ${spacingMixin};
  `;
